<template>
  <svg width="586" height="172" viewBox="0 0 586 172" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6012_41595)">
      <path d="M245.903 107.092V65.0828H342.444L310.454 130.165H340.498V172H245.903L277.892 107.092H245.903Z" fill="#00D572"/>
      <path d="M144.325 107.092V65.0828H239.093L207.103 130.165H239.093V172H142.38L174.369 107.092H144.325Z" fill="#00D572"/>
      <path d="M129.733 65.0828H83.0357V172H129.733V65.0828Z" fill="#00D572"/>
      <path
        d="M94.5383 11.4783L76.9697 51.9729C72.8494 49.0014 68.5574 47.1951 63.2926 47.1951C55.2809 47.1951 48.8715 53.1382 
          48.8715 64.4417V65.0827H73.0211V106.684H48.9287V171.942H0V56.5176C0 22.607 24.7791 0 55.567 0C70.5603 0 84.4092 5.18564 94.5383 11.4783Z"
        fill="#00D572"
      />
      <path d="M451.861 64.7913H348.51V106.684H451.861V64.7913Z" fill="white"/>
      <path d="M420.787 66.7141H379.641V171.942H420.787V66.7141Z" fill="white"/>
      <path d="M499.016 172L459.873 66.7141H507.371L546.514 172H499.016Z" fill="white"/>
      <path d="M546.8 172L586 66.7141H538.502L499.359 172H546.8Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_6012_41595">
        <rect width="586" height="172" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
